export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8378.87a3b237.jpg";